import { useState } from 'react'
import { ToastSubType } from '../../constants'
import { useNotification } from '../useNotification'
import { Button } from '@mui/material'
import { CloseButton } from '../useNotification/CloseButton'
import { closeSnackbar } from 'notistack'
import { AvailabilitiesResponse } from '../../types'
import { UseQueryResult } from 'react-query'

interface Props {
  results: UseQueryResult<AvailabilitiesResponse, unknown>
}

const MAX_REQUEST_AVAILABILITY_RETRIES = 2

const useAvailabilitiesRetry = ({ results }: Props) => {
  const { notify } = useNotification()
  const [retries, setRetries] = useState(0)

  const onRetryAction = () => {
    return (
      <>
        {retries < MAX_REQUEST_AVAILABILITY_RETRIES && (
          <Button variant="outlined" size="small" color="inherit" onClick={refetch}>
            Try Again
          </Button>
        )}
        <CloseButton />
      </>
    )
  }

  const refetch = () => {
    setRetries(retries + 1)
    results.refetch()
    closeSnackbar()
  }

  const showSnackbar = () => {
    notify({ message: `Availabilities request failed.`, type: ToastSubType.UNHANDLED_ERROR }, 'error', {
      autoHideDuration: null,
      hideIconVariant: true,
      persist: true,
      preventDuplicate: true,
      action: onRetryAction,
    })
  }

  const checkAvailabilitiesRequestRetry = () => {
    if (results.data?.responseStatus && results.data?.responseStatus !== 200) {
      showSnackbar()
    }
  }

  return { checkAvailabilitiesRequestRetry }
}

export { useAvailabilitiesRetry }
